import {active} from "./const.js";
import {md} from "./const.js";
import $ from "jquery";

$('.js-accordionHeader').on('click', function() {
  if (window.innerWidth <= md) {
    $(this).toggleClass(active);
    $(this).next('.js-accordionBody').slideToggle();
    return false;
  }
});
